import { ROUTES_WITH_HEADER, ROUTE_HOME } from 'common/config/constants';
import { getKey } from 'common/utils';
import { getRootPath } from 'common/utils/helpers';
import { toNumber } from 'lodash';

export const getRouteMatch = (pathname: string) => toNumber(pathname.split('/').pop());

export const isMenuShown = (locationPath: string) =>
  ROUTES_WITH_HEADER.includes(getRootPath(locationPath));

export const getInitialFocusKey = (locationPath: string) =>
  getKey('menu-item', undefined, getRootPath(ROUTE_HOME));
